import { mapState } from "pinia";
import useBrandingStore from "%/stores/branding-store";

const BrandedTextMixinStaging = {
  computed: {
    ...mapState(useBrandingStore, {
      brandingConfiguration: "configuration",
    }),
  },
};

export { BrandedTextMixinStaging };
